import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'set-role',
  templateUrl: './modal-set-role.template.html',
  styles: [`
    .modal-body {
      background-color: ghostwhite
    }

    .group-permission {
      border: 1px solid gainsboro;
      border-left: none;
      border-right: none;
      padding: 0 0 5px 10px;
      background-color: white;
      margin: 0 -20px 10px -20px;
    }

    .group__permission-all {
      margin: -12px 0 6px -6px;
    }

    h4.example-title {
      padding-left: 0 !important;
    }
  `],
  providers: [EvsUserService],
})

export class ModalSetRoleComponent implements OnInit {

  user: any;
  permissions: any = [];
  loading = true;
  isCheckAllGroup = false;
  isCheckGroup = [];
  parentCheckbox = false;

  constructor(public bsModalRef: BsModalRef,
    private userService: EvsUserService,
    private toastr: ToastrService,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.loadData(this.user.id);
  }

  setChangeValue() {
    this.isCheckGroup.map((res, i) => {
      let flag = true
      res.users.map((val) => {
        if (!val.has_permission) {
          flag = false
        }
      })
      this.isCheckGroup[i]['type'] = flag
    })
  }

  setChangeValueAll() {
    this.parentCheckbox = this.isCheckGroup.find(({ type }) => type === false) ? false : true;
  }

  loadData(user_id) {
    this.userService.getPermissions(user_id).toPromise().then((res: any) => {
      this.loading = false;
      if (res.error == false) {
        const my_permissions: Array<any> = res.data.my_permissions;
        const routes_fillter = res.data.routes.filter((item) => item.id !== 92 && item.id !== 93)
        console.log('routes_fillter', routes_fillter)
        const permission: any = [];
        for (const item of routes_fillter) {
          if (my_permissions.indexOf(item.id) != -1) {
            item.has_permission = true;
          }
          permission.push(item);
        }
        this.permissions = permission;
        this.isCheckGroup = _.chain(this.permissions).groupBy('group').map((value, key) => ({ group: key, users: value })).value();
        this.setChangeValue();
        this.setChangeValueAll();
      } else {
      }
    }).catch((err: any) => {
      this.loading = false;
    })
  }

  checkAllParentGroup() {
    this.isCheckGroup.map((res, i) => {
      res.type = this.parentCheckbox
      res.users.map((val) => {
        val.has_permission = this.parentCheckbox
      })
    })
  }

  checkAllGroup(name) {
    this.isCheckGroup.map((res, i) => {
      if (name === res.group) {
        res.users.map((val) => {
          val.has_permission = res.type
        })
      }
    });
    this.parentCheckbox = this.isCheckGroup.find(({ type }) => type === false) ? false : true;
  }

  checkItemGroup(name) {
    this.isCheckGroup.map((res) => {
      if (name === res.group) {
        const results = [];
        res.users.map((val) => {
          results.push(val)
        })
        res.type = results.find(({ has_permission }) => has_permission === false) ? false : true;
      }
    });
    this.parentCheckbox = this.isCheckGroup.find(({ type }) => type === false) ? false : true;
  }

  save_permission(data: any) {
    const list: Array<any> = [];
    let k: any;
    for (k in data) {
      if (data[k] == true) {
        list.push(k);
      }
    }
    this.userService.setPermission(this.user.id, { 'permissions': list }).toPromise().then((res: any) => {
      if (res.error == false) {
        this.bsModalRef.hide();
        const mess = this.translate.instant('PHAN_QUYEN_THANH_CONG');
        this.toastr.success(mess, this.translate.instant('THANH_CONG_COLON'), {
          timeOut: 4000,
          positionClass: 'toast-top-right'
        });
      } else {
        const mess = this.translate.instant('THAO_TAC_KHONG_THANH_CONG_VUI_LONG_THU_LAI');
        this.toastr.warning(mess, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-top-right'
        });
      }
    }).catch((err: any) => {
      const mess = this.translate.instant('THAO_TAC_KHONG_THANH_CONG_VUI_LONG_THU_LAI');
      this.toastr.warning(mess, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right'
      });
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modalSetRole.component.ts